export default {
  code: {
    500: '@:error.message.serverError',
    10001002: '未找到该资源',
    10001004: '缺少必要参数',
    10001005: '无权访问该资源',
    20003002: '用户名或密码错误',
    20003003: 'loginCode已失效',
    20002003: '获取草稿箱内容失败，请在管理后台-雇主品牌管理-微信模板消息管理中配置正确的微信公众号开发者ID (AppID)和微信公众号开发者密码 (AppKey)后保存',
    20002004: '获取微信图文消息失败, 请稍后再试',
    20001001: '此帐号已经停用。如有疑问请致电 400-990-3308',
    20001002: '系统检测到您输入的是HR帐号，目前HR帐号无法参与referral项目，其他HR功能请通过电脑端访问菁客网站<span>www.ajinga.com</span>或者下载APP菁客招聘进行操作',
    20001003: '系统检测到您输入的是公司员工帐号，目前员工帐号暂不支持微信绑定，请直接<a href="">点击此处</a>继续',
    20001005: '求职者状态中文名称或英文名称已存在',
    20005001: '可分配的积分余额不足，请联系你的菁客客户成功顾问获取更多支持',
    20005002: '尚未配置微信公众号，请先配置关联公众号。',
    20005003: '请先完成主页设置。',
    20005004: '请先完成员工主页设置。',
    20005006: '这是个有关联的对象，不能删除。',
    20005007: '不能设置上属公司为此公司的下属公司',
    20005008: '此公司已被注册。',
    20005009: '用户名已存在',
    20008001: '无法创建，分组名称已存在。',
    20008002: '无法创建或修改，问题名称已存在。',
    20008003: '问卷答案为空。',
    20008004: '该职位下没有问卷。',
    20009001: '您不能创建更多职位，请联系菁客。',
    20009002: '该第三方职位ID已经被关联到其他的职位。',
    20009003: '领英在线职位已达到最大，请联系领英管理员或者菁客客户成功经理获取更多帮助。',
    20009004: '前程无忧的发布积分不够，请联系管理员!',
    20010001: '一个调查只能有一个净推荐值问题',
    20010002: '一个调查只能有一个净推荐值问题',
    20010003: '当前类型的问卷不能重复创建',
    20010004: '包含此流程的问卷已经含有NPS题目',
    20010005: '无法创建或修改，问卷名称已存在。',
    20010006: '答案长度超过限制',
    20011001: '该邮箱账号为非求职者账号，请更换一个邮箱。',
    20011002: '该邮箱账号不能申请该职位，请更换一个邮箱。',
    20011003: '该邮箱账号已申请该职位，请更换一个邮箱。',
    20011004: '该邮箱账号已注册使用，请更换一个邮箱。',
    20011005: '当前锁定规则正在使用，无法修改',
    20011006: '该候选人已存在于公司人才库中，请勿重复上传！',
    20011007: '求职者需要邮箱或者手机号',
    20011010: '您上传的候选人可能是重复候选人，请尽快联系对应的招聘专员。',
    20007001: '用户名或密码错误',
    20007002: '用户名或密码错误',
    20007003: '用户名或密码错误',
    20007004: '创建密码失败，没有找到该账号',
    20007005: '账号不存在，请重新输入',
    20007006: '在24小时内不能重置密码超过五次',
    20006021: '在24小时内不能重置密码超过五次',
    20006043: 'Teams权限缺失',
    20007007: '密码已过期，请重置密码!',
    20007008: '该邀请已评估，不能重复评估！',
    60010001: '同一公司下同一平台只能创建一个账号',
    20002008: '已经开始的任务不能修改！',
    20002009: '标签列表错误，请重新检查',
    20002011: '所选上属分组已超过最大层级限制',
    20002012: '微网站分组已经被使用，不能删除！',
    20002013: 'Zoom用户电子邮件未找到',
    20012001: '该协议已经存在',
    20012002: '该协议已经启用不允许编辑',
    20012003: '您已经发送了3次协议同意收集邮件，如果有问题，请联系候选人或菁客客户成功顾问获取更多支持。',
    20015001: '这个宣传大使已经存在了',
    20015002: '每个宣传大使至少需要一个邮箱或者一个手机号码',
    20015003: '职位宣传大使不存在',
    20016001: '此邮箱地址已被注册。',
    20016002: '该猎头在当前公司已经存在，请避免重复添加.',
    20017001: '此账号名已经存在!',
    20018001: '哎呀，AI开了一点小差。模型正在重新思考，请于几分钟后重试。',
    20018002: '哎呀，AI开了一点小差。模型正在重新思考，请于几分钟后重试。',
    20020001: '该追踪代码与菁客平台级别重复。请联系你的菁客客户成功经理获取更多信息。',
    20021000: '问卷管理业务处理失败',
    20021001: '公司不能为空',
    20021002: '继承资源只读，不能修改',
    20021003: '参数必须为整数',
    20021004: '状态必须为启用或停用',
    20021116: '分制类型无效',
    20021117: '分制配置无效',
    20021201: '问题不存在',
    20021202: '问题不在当前公司范围内',
    20021203: '问题已锁定，不能修改',
    20021204: '问题已停用',
    20021205: '问题标题不能为空',
    20021206: '问题类型无效',
    20021207: '只有选择题可以设置选项',
    20021208: '选择题至少需要两个选项',
    20021209: '问题选项必须为对象',
    20021210: '选项排序必须为整数',
    20021211: '选项排序重复',
    20021212: '选项标签不能为空',
    20021301: '问卷不存在',
    20021302: '问卷不在当前公司范围内',
    20021303: '问卷名称不能为空',
    20021304: '问卷问题明细必须为列表',
    20021305: '问卷问题明细不存在',
    20021306: '问卷问题明细必须为对象',
    20021307: '问题 ID 必须为整数',
    20021308: '问卷问题明细与问题 ID 不匹配',
    20021309: '问卷中的问题重复',
    20021310: '问卷问题排序重复',
    20021311: '存在评分题时必须选择分制',
    20021312: '评分题权重总和必须等于 100%',
    20021313: '问卷结构已锁定，不能修改题目结构',
    20021314: '排序必须为整数',
    20021315: '评分权重必须为数字',
    20021316: '评分题必须填写评分权重',
    20021317: '评分权重必须在 0 到 100 之间',
    20021318: '只有评分题可以设置评分权重',
    20021402: '问卷用途类型无效',
    20021403: '历史邀请记录不存在',
    20021404: '历史邀请记录未关联问卷',
    20021405: '运行时上下文类型无效',
    20021406: '运行时问卷项不存在',
    20021407: '缺少必填答案',
    20021408: '问卷回答已提交，不能修改',
    20021409: '运行时问卷记录未关联问卷',
    20021410: '手动评分模式不接受问卷答案',
    20021502: '小组面试至少需要选择两位候选人。',
    20021503: '小组面试至少需要选择两位面试官。',
    20021504: '请输入小组面试名称。',
    20021505: '小组面试名称不能超过 255 个字符。',
    20021506: '请先选择问卷，再分配面试官。',
    20021507: '所选小组面试问卷无效。',
    20021508: '所选小组面试问卷中没有问题。',
    20021509: '问卷问题的面试官分配无效。',
    20021510: '请为每个问题至少分配一位面试官。',
    20021511: '已分配的面试官不在本次邀请名单中。',
    20021513: '请为问卷中的每个问题分配面试官。',
    20021514: '请为每位受邀面试官至少分配一个问题。',
    20006018: '短信验证码当日获取已超过最大次数，请于24小时后再次尝试',
    20006020: '账号已禁用',
    20006024: '该手机号码已经被绑定了',
    20006025: '请联系菁客申请添加更多的账户',
    20006042: '该邮箱或手机号帐号已被禁用',
    20006008: '此邮箱地址已被注册',
    20006009: '密码必须包含大小写字母和数字，长度至少10位，特殊符号只能是_#@.-',
    20006010: '手机号或验证码不正确',
    20006013: '图形验证码无效或已失效，请刷新图形验证码！',
    20006027: '输入的邮箱地址无效或此邮箱地址已被注册',
    20006029: '更新账号手机号失败',
    20006030: '你正在使用此手机号码',
    20006032: '此电子邮件是求职者帐户，不能是管理员！',
    20006033: '此电子邮件是员工帐户，不能是管理员！',
    20006034: '用户有关联公司',
    20006035: '此电子邮件已具有所选角色！',
    20006036: '用户不存在',
    20006037: '每日删除次数为100，当天注销次数已经使用完毕',
    20006038: '请输入一个有效的邮箱。',
    20006039: '邮箱已存在，请重新输入注销后的邮箱',
    20006040: '密码错误',
    20006041: '请确认密码相同',
    70001002: '邮件模板不存在',
    70001003: '重复提交',
    70001004: '邮件模板不存在',
    70001005: '系统模板不存在',
    70001006: '请输入一个不同的名称',
    70001007: '模板类型不存在',
    70001008: '模板已经被使用,无法删除!',
    20011008: '由于推荐奖励计划，此职位的状态变更流程逻辑固定。请根据推荐流程逻辑更新下一个状态。',
    20011009: '由于推荐奖励计划，此职位的状态变更流程逻辑固定。不能改变最终状态的候选人',
    20011011: '由于推荐奖励计划，此职位的人员数量固定。请调整推荐计划中的人员数量，或选择其他状态。',
    20011012: '上传失败：出于安全考虑，该文件类型/内容已被系统阻止。',
    20011013: '上传失败：出于安全考虑，该文件类型/内容已被系统阻止。',
    90000001: '手机号格式不符合要求！不能邀请AI面试',
    90000002: '邮箱或者手机号必须要存在一个',
    90000003: '邮箱和手机号必填，请补充邮箱和手机号后再次邀请。',
    90000004: '服务配置失败，请联系菁客客户成功经理获取更多帮助。'
  },
  message: {
    serverError: '服务器发生错误，请稍后再试'
  },
  page: {
    internalOnlyMicroSite: {
      title: '您还不是内部员工',
      message: {
        notEmployee: '哎呀！',
        onlyInternal: '此页面只有内部员工可以访问！',
        toRegister: {
          prefix: '请点击',
          content: '这里',
          suffix: '先注册或登录您{companyName}的员工账号。',
          inactive: '您的员工账号尚未审核，请查看邮件激活身份或者联系您的HR。'
        }
      }
    },
    noAccessToComapnySurvey: {
      title: '您没有权限访问此问卷',
      notCompanyEmployee: '您不是{companyName}员工，没有权限访问此问卷。',
      employeeNoPass: '您的员工审核还未通过，请联系HR。'
    },
    linkExpired: {
      title: '链接已失效',
      content: '因为我们的隐私和数据安全政策，<br>此链接已于30天后失效。'
    }
  }
}
